module.exports = __webpack_public_path__ + "img/coin-entry.c0a4368c.png";